import AxiosInstance from "../config/AxiosInstance";

// scope 'support' lists InnovX support roles; omitted, the API returns the roles this company may see.
const getRoles = async (payload: { page: number; limit: number; searchValue?: string; scope?: 'tenant' | 'support' | 'platform'; [key: string]: unknown }) => {
    try {
        const { data } = await AxiosInstance.post('/api/user-role/list', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getDetailsRoles = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/user-role/' + encodeURIComponent(id));
        return { data };
    } catch (error) {
        throw error;
    }
};

const createRoles = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/user-role', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const updateRoles = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/user-role/' + encodeURIComponent(id), payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getListRolesPermission = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/modules/list');
        return { data };
    } catch (error) {
        throw error;
    }
}

// 409 { message, userCount } while any user, company link or staff grant still holds the role.
const deleteRole = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/user-role/' + encodeURIComponent(id));
        return { data };
    } catch (error) {
        throw error;
    }
};

export {
    getRoles,
    getDetailsRoles,
    createRoles,
    updateRoles,
    getListRolesPermission,
    deleteRole
}